<template>
  <basic-container>
    <div class="journalDetails-container">
      <!-- 详情信息 -->
      <div
        class="detail_container"
        v-loading="loadingContent"
        v-if="detailsData"
      >
        <div class="card_first">
          <img src="https://www.ifjournals.com/file/2053-1583.gif" alt="" />
          <div class="card_first_right">
            <div class="breContent">
              <h5>{{ detailsData.periodicalsName }}</h5>
              <p>{{ $t("journalDe.issn") }} {{ detailsData.issn || "-" }}</p>
              <p>{{ $t("journalDe.eissn") }} {{ detailsData.eissn || "-" }}</p>
            </div>
            <div class="type">
              <div v-for="item in detailsData.sciList">
                <span class="blockDetail">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card_second">
          <p>
            <span class="span_color_a">{{ $t("journalDe.detail") }}</span>
          </p>
          <hr />
          <p class="p_b"></p>

          <div class="journalBrev">
            <el-row
              v-for="(row, index) in brevD"
              :key="'short-' + index"
              class="short"
            >
              <el-col
                :span="6"
                v-for="(item, colIndex) in row"
                :key="'col-' + index + '-' + colIndex"
              >
                <div
                  class="grid-content"
                  :class="{
                    'bg-purple': item.label,
                    'left-value': item.value || item.value === 0, // 确保 left-value 类只在有值时应用
                  }"
                >
                  {{ item.label || item.value || "-" }}
                </div>
              </el-col>
            </el-row>

            <el-row
              v-for="(item, index2) in brevD2"
              :key="'long-' + index2"
              class="long"
              :class="{ 'last-row': index2 === brevD2.length - 1 }"
            >
              <el-col :span="6">
                <div class="grid-content bg-purple">{{ item.label }}</div>
              </el-col>
              <el-col :span="18">
                <div class="grid-content bg-long">{{ item.value || "-" }}</div>
              </el-col>
            </el-row>

            <el-row
              v-for="(item, index3) in brevD3"
              :key="'long2-' + index3"
              class="long2"
              :class="{ 'last-row': index3 === brevD3.length - 1 }"
            >
              <el-col :span="6">
                <div class="grid-content bg-purple">{{ item.label }}</div>
              </el-col>
              <el-col :span="18">
                <div class="grid-content bg-long">{{ item.value || "-" }}</div>
              </el-col>
            </el-row>

            <el-row
              v-for="(row, index4) in brevD4"
              :key="'short2-' + index4"
              class="short2"
            >
              <el-col
                :span="6"
                v-for="(item, colIndex4) in row"
                :key="'col-' + index4 + '-' + colIndex4"
              >
                <div
                  class="grid-content"
                  :class="{
                    'bg-purple': item.label,
                    'left-value': item.value || item.value === 0, // 确保 left-value 类只在有值时应用
                  }"
                >
                  {{ item.label || item.value || "-" }}
                </div>
              </el-col>
            </el-row>

            <div class="last-rowD">
              <div class="l1">{{ $t("journalDe.issn") }}</div>
              <div class="l2">
                <div>{{ detailsData.scopusSubject || "-" }}</div>
                <div>
                  <span
                    >{{ $t("journalDe.partition")
                    }}{{ detailsData.scopusPartition || "-" }}</span
                  >
                  <span
                    >{{ $t("journalDe.rank")
                    }}{{ detailsData.ranking || "-" }}</span
                  >
                  <span
                    >{{ $t("journalDe.percentage")
                    }}{{ detailsData.percentage || "-" }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 5年影响 -->
        <div class="card_third">
          <p>
            <span class="span_color_a">{{ $t("journalDe.echartTitle") }}</span>
          </p>
          <hr />
          <p class="p_b"></p>
          <div class="impact_container">
            <div
              id="impactMain"
              ref="impactC"
              style="width: 618px; height: 500px"
            ></div>
          </div>
        </div>
      </div>

      <!-- 当结果为空展示 -->
      <div class="emptyContainer" v-else>
        <img src="@/assets/images/empty.png" alt="" />
        <p class="mt-3">暂无查询到相关数据</p>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getDetailsData } from "@/api/journal/journalDetails";
import * as echarts from "echarts";

export default {
  name: "journalDetails",
  data() {
    return {
      loadingContent: false,
      query: {
        issn: "",
        type: "",
      },
      detailsData: {},
      impactList: [],
      brevD: [],
      brevD2: [],
      brevD3: [],
      brevD4: [],
      impactChart: null,
    };
  },
  created() {
    this.query.issn = this.$route.query.issn;
    this.query.type = this.$route.query.type;
  },
  mounted() {
    this.initChart();
    this.getAllData();
    window.addEventListener("resize", () => {
      this.impactChart.resize();
    });
  },
  methods: {
    initChart() {
      var chartDom = document.getElementById("impactMain");
      if (chartDom) {
        this.impactChart = echarts.init(chartDom);
      }
    },
    getImpact() {
      if (this.impactChart) {
        this.impactChart.showLoading();
        // 处理 impactList，将空值替换为 0
        this.impactList = [
          this.detailsData.impactFactorsA,
          this.detailsData.impactFactorsB,
          this.detailsData.impactFactorsC,
          this.detailsData.impactFactorsD,
          this.detailsData.impactFactorsE,
        ];
        var processedImpactList = this.impactList.map((value) =>
          value !== null && value !== undefined ? value : 0
        );
        var option = {
          title: {
            text: "",
          },
          tooltip: {
            showContent: false,
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "cross", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          xAxis: {
            data: ["2019", "2020", "2021", "2022", "2023"],
          },
          yAxis: {},
          series: [
            {
              name: "示例",
              type: "bar",
              data: processedImpactList,
            },
          ],
        };
        this.impactChart.hideLoading();
        this.impactChart.setOption(option);
      }
    },

    getAllData() {
      let url = "";
      let issn = this.query.issn;
      let _this = this;

      if (
        _this.query.type == "SSCI" ||
        _this.query.type == "SCI" ||
        _this.query.type == "SCIE"
      ) {
        url = "/jsb-api/detail/periodicalsDetails/" + issn;
      } else if (_this.query.type == "ESCI") {
        url = "/jsb-api/detail/eiJournalDetails/" + issn;
      } else if (_this.query.type == "AHCI") {
        url = "/jsb-api/detail/ahciJournalDetails/" + issn;
      }
      _this.fetchData(url);
    },

    fetchData(url) {
      this.loadingContent = true;
      getDetailsData(url).then((res) => {
        this.detailsData = res.data;
        if (this.detailsData) {
          this.getBreData();
          this.getImpact();
        }

        this.loadingContent = false;
      });
    },
    getBreData() {
      this.brevD = [
        [
          { label: this.$t("journalDe.brief") },
          { value: this.detailsData.abbreviation },
          { label: this.$t("journalDe.publisher") },
          { value: this.detailsData.publisher },
        ],
        [
          { label: this.$t("journalDe.jci") },
          { value: this.detailsData.jci },
          { label: this.$t("journalDe.cycle") },
          { value: this.detailsData.cycle },
        ],
        [
          { label: this.$t("journalDe.impactIndex") },
          { value: this.detailsData.impactA + "-" + this.detailsData.impactB },
          { label: this.$t("journalDe.country") },
          { value: this.detailsData.differentCountries },
        ],
        [
          { label: this.$t("journalDe.yearPulisherCount") },
          { value: this.detailsData.yearNum },
          { label: this.$t("journalDe.chineseRate") },
          { value: this.detailsData.chinaProportion },
        ],
      ];
      this.brevD2 = [
        {
          label: this.$t("journalDe.subject"),
          value: this.detailsData.esiSubject,
        },
        {
          label: this.$t("journalDe.WhetherLibrary"),
          value: this.detailsData.includeI,
        },
        {
          label: this.$t("journalDe.warning"),
          value: this.detailsData.warningW,
        },
        {
          label: this.$t("journalDe.webSite"),
          value: this.detailsData.contributionConnect,
        },
        { label: this.$t("journalDe.domesticDivision"), value: "" },
      ];

      this.brevD3 = [
        {
          label: this.$t("journalDe.bigType"),
          value: this.detailsData.bigPartitionB,
        },
        {
          label: this.$t("journalDe.smallType"),
          value: this.detailsData.smallPartitionB,
        },
      ];
      this.brevD4 = [
        [
          { label: this.$t("journalDe.hIndex") },
          { value: this.detailsData.hIndex },
          { label: this.$t("journalDe.citeMySelf") },
          { value: this.detailsData.selfCitationRate },
        ],
        [
          { label: this.$t("journalDe.isOa") },
          { value: this.detailsData.isOa == "NO" ? "否" : "是" },
          { label: this.$t("journalDe.citeScore")},
          { value: this.detailsData.citeScore },
        ],
        [
          { label: this.$t("journalDe.snip") },
          { value: this.detailsData.snip },
          { label: this.$t("journalDe.sjr") },
          { value: this.detailsData.sjr },
        ],
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/originCss/journalDetail.css";
</style>
